export default __webpack_public_path__ + "97a4fc8308be41e4772fe6a25e52cc93.jpg";